import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

export type ClearingCodeMasterRecord = {
  clearingCodeFullForm: string;
  clearingCode: string;
};

/**
 * GET API call to retrieve clearing codes master data.
 * Endpoint: /master/clearing-codes
 *
 * Response shapes in this codebase vary between:
 * - { data: T } wrappers, and
 * - raw payloads (e.g. string[]).
 *
 * This normalizes to an array payload.
 */
export const clearingCodesMasterApi = async (): Promise<
  ClearingCodeMasterRecord[]
> => {
  try {
    const response = await axios.get(getUrl(ApiType.CLEARING_CODES));

    const payload = (response as any)?.data;
    const data = payload?.data ?? payload ?? [];

    if (!Array.isArray(data)) return [];

    return data
      .map((item: any) => ({
        clearingCodeFullForm: String(item?.clearingCodeFullForm ?? ""),
        clearingCode: String(item?.clearingCode ?? ""),
      }))
      .filter(
        (record: ClearingCodeMasterRecord) =>
          Boolean(record.clearingCode) && Boolean(record.clearingCodeFullForm)
      );
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.clearingCodesMaster, {
      badRequestOrder: "errorsFirst",
    });
  }
};
